import { commonMessages } from '../../../../../util/messages'

export const ratingCompliancesRulesMessages = {
  common: commonMessages,
  update: {
    success: 'Rating compliance rule successfully updated',
    error: 'Error updating rating compliance rule',
  },
}
